import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { message, Spin } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import IndeterminateCheckbox from 'components/@extended/IndeterminateCheckbox';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import { useIdentityBulkMutation } from 'store/features/process/processApi';
import { groupBy, isEqual } from 'lodash';
import { toastConfig } from 'config';
import controls from 'assets/images/icons/deactivated.svg';
import { activeInactiveStatus } from 'pages/globals/global';
import { hasGlKey } from '../CustomComponents/LeaseUtils/helper';
import { IdentityFeaturedTable } from './IdentityFeaturedTable';

import dayjs from 'dayjs';
import { Box, useTheme } from '@mui/material';
// import { useDispatch } from 'react-redux';
const measureText = (text, font = '14px Arial') => {
	// Re-use the same canvas element to be more efficient.
	const canvas = measureText.canvas || (measureText.canvas = document.createElement('canvas'));
	const context = canvas.getContext('2d');
	if (context.font !== font) {
		context.font = font;
	}
	const metrics = context.measureText(String(text)); // Ensure text is a string
	return metrics.width;
};
const MAX_COLUMN_WIDTHS = {
	leaseTitle: 300,
	leaseId: 150,
};
const ListViewLeaseManagementArea = ({
	leaseList = [],
	isLoading,
	selectedTabName = 'All',
	currentRoute = 'v6',
	// isRowClick = true,
	setData,
	processDetails: passedProcessDetails,
	permissionsObject = null,
	headMetaData = null,
	expectedURLToRedirect = null,
	refetchData = () => {},
}) => {
	// console.log(leaseList, 'leaseList123');
	const theme = useTheme();
	const navigate = useNavigate();
	const [submitData, setSubmitData] = useState(null);
	const [rowSelection, setRowSelection] = useState([]);
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	// console.log(selectedRowKeys, 'selectedRowKeys123');
	const [modalData, setModalData] = useState({});
	const [isRowClick, setIsRowClick] = useState(false);
	// console.log(isRowClick, 'isRowClick123');
	const [columnWidths, setColumnWidths] = useState({});
	const [showModal, setShowModal] = useState(false);
	// const [minLoading, setMinLoading] = useState(true);
	const { state } = useLocation();
	// const [GetSolutionName, { data: processDetails }] = useGetSolutionNameMutation();

	// console.log(selectedTabName, 'selectedTabName123');

	const [IdentityBulk, { data: activationData, isLoading: isBulkActionLoading, isSuccess: isCaseSuccess, isError: isCaseError }] =
		useIdentityBulkMutation();
	// const [
	// 	GetSpacialCaseHeader,
	// 	{
	// 		data: tableHeader,
	// 	},
	// ] = useGetIdentityHeaderMutation();
	// const dispatch = useDispatch();
	// Use passed processDetails if available, otherwise use the one from API
	const currentProcessDetails = passedProcessDetails;
	// Get route paths based on version
	const getRoutePaths = () => {
		const basePath = `/static/lease-record-management-${currentRoute}`;
		return {
			details: `${basePath}/details`,
			edit: `${basePath}/edit`,
			list: `${basePath}`, // Default route ID
		};
	};
	// const { creatorOrganizationId } = useSelector((state) => state.profile.profileData);
	// const companyCode = creatorOrganizationId;
	// useEffect(() => {
	// 	if (state?.processCode) {
	// 		GetSpacialCaseHeader({
	// 			operation: 'get-single',
	// 			companyCode,
	// 			processCode: state?.processCode,
	// 			suffixCode: '',
	// 		});
	// 		setIsRowClick(tableHeader?.meta?.editStyle?.toLowerCase() === 'form' ? true : false);
	// 	}
	// }, []);

	// useEffect(() => {
	// 	if (rowSelection?.length) {
	// 		let arr = [];
	//
	// 		rowSelection?.forEach((item) => {
	// 			arr.push(item.original);
	// 		});
	//
	// 		setSelectedRowKeys(groupBy(arr, ({ activationStatus }) => activationStatus));
	// 	}
	// }, [rowSelection]);
	const extractCleanRowData = (selection) => {
		return selection.map((item) => {
			// Extract only the necessary data, avoiding circular references
			return {
				_id: item.original?._id || item._id,
				id: item.original?.id || item.id,
				activationStatus: item.original?.activationStatus,
				recordStatus: item.original?.recordStatus,
				approverUserId: item.original?.approverUserId,
				// Add other necessary fields without circular references
				data: item.original?.data
					? {
							leaseId: item.original.data.leaseId,
							leaseTitle: item.original.data.leaseTitle,
							// Add other needed data fields
						}
					: item.original,
			};
		});
	};
	const areSelectedKeysEqual = (prev, current) => {
		// Use lodash isEqual for deep comparison instead of JSON.stringify
		return isEqual(prev, current);
	};
	const updateSelectedKeys = useCallback((selection) => {
		if (selection?.length) {
			// Extract clean data to avoid circular references
			const cleanSelection = extractCleanRowData(selection);

			const grouped = groupBy(cleanSelection, ({ activationStatus }) => activationStatus);

			// Use deep comparison instead of JSON.stringify
			setSelectedRowKeys((prev) => {
				if (!areSelectedKeysEqual(prev, grouped)) {
					return grouped;
				}
				return prev; // No update = no re-render
			});
		} else {
			// Handle empty selection
			setSelectedRowKeys((prev) => {
				if (Object.keys(prev).length > 0) {
					return {};
				}
				return prev;
			});
		}
	}, []);

	useEffect(() => {
		updateSelectedKeys(rowSelection);
	}, [rowSelection, updateSelectedKeys]);

	useEffect(() => {
		if (isCaseSuccess) {
			if (activationData?.successCount > 0) {
				toast.success(`Success! ${activationData?.successCount} Action completed`, toastConfig);
			}

			if (activationData?.failedCount > 0) {
				toast.error(`Failed! ${activationData?.failedCount} Action incomplete`, toastConfig);
			}

			// Refetch data after successful operations for proper sync
			refetchData();

			setSelectedRowKeys([]);
			setRowSelection({});
			setSubmitData(null);
		} else if (isCaseError) {
			setSubmitData(null);

			toast.error(`${currentProcessDetails?.name} status updating error!`, toastConfig);
		}
	}, [isCaseError, isCaseSuccess]);

	const routes = getRoutePaths();

	// useEffect(() => {
	// 	if (state?.processCode) {
	// 		GetSolutionName({
	// 			code: state?.processCode,
	// 		});
	// 	} else if (!passedProcessDetails) {
	// 		navigate(-1);
	// 	}
	// }, []);

	// Clear selection when tab changes
	useEffect(() => {
		setRowSelection([]);
	}, [selectedTabName]);

	// Add useEffect for minimum loading time
	// useEffect(() => {
	// 	const timer = setTimeout(() => {
	// 		setMinLoading(false);
	// 	}, 100);

	// 	return () => clearTimeout(timer);
	// }, []);

	// Static column definitions with react-table v7 selection pattern for ComptrollerDataTable
	// const COLUMNS = useMemo(
	// 	() => [
	// 		{
	// 			id: 'Selection',
	// 			Header: ({ getToggleAllRowsSelectedProps }) => (
	// 				<IndeterminateCheckbox sx={{ color: 'white', padding: '0px' }} {...getToggleAllRowsSelectedProps()} />
	// 			),
	// 			Cell: ({ row, index }) => <IndeterminateCheckbox id={index} {...row.getToggleRowSelectedProps()} />,
	// 			onClicked: true,
	// 			align: 'center',
	// 			cellAlign: 'center',
	// 		},
	// 		{
	// 			Header: 'Lease ID',
	// 			accessor: (row) => row.data?.leaseId || row.leaseId || 'N/A',
	// 		},
	// 		{
	// 			Header: 'Lease Description',
	// 			accessor: (row) => row.data?.leaseTitle || row.leaseTitle || 'N/A',
	// 		},
	// 		{
	// 			Header: 'Lease Start Date',
	// 			accessor: (row) => {
	// 				const startDate = row.data?.leaseStartDate || row.leaseStartDate;
	// 				return startDate ? dayjs(startDate)?.format('YYYY-MM-DD') : 'N/A';
	// 			},
	// 		},
	// 		{
	// 			Header: 'Lease End Date',
	// 			accessor: (row) => {
	// 				const endDate = row.data?.leaseEndDate || row.leaseEndDate;
	// 				const formattedDate = endDate ? endDate.split('T')[0] : 'N/A';
	// 				return formattedDate;
	// 			},
	// 		},
	// 		{
	// 			Header: 'Lease Term',
	// 			accessor: (row) => {
	// 				const term = row.data?.leaseTerm || row.leaseTerm;
	// 				return term ? `${term}` : 'N/A';
	// 			},
	// 			align: 'center',
	// 			cellAlign: 'center',
	// 		},
	// 		{
	// 			Header: 'Payment Modality',
	// 			accessor: (row) => {
	// 				const value = row.data?.paymentModality || row.paymentModality;
	// 				return value === 'Start' ? 'Advance Basis' : 'Accrual Basis';
	// 			},
	// 		},
	// 		{
	// 			Header: 'Payment Frequency',
	// 			accessor: (row) => row.data?.paymentFrequency || row.paymentFrequency || 'N/A',
	// 		},
	// 		{
	// 			Header: 'IBR',
	// 			accessor: (row) => {
	// 				const rate = row.data?.initialDiscountRate || row.initialDiscountRate;
	// 				return rate ? `${rate}` : 'N/A';
	// 			},
	// 			align: 'center',
	// 			cellAlign: 'center',
	// 		},
	// 		...(leaseList?.some((item) => item.approverFullName)
	// 			? [
	// 					{
	// 						Header: 'Approver',
	// 						accessor: (row) => {
	// 							const approver = row.approverFullName || '';
	// 							return approver ? `${approver}` : 'N/A';
	// 						},
	// 					},
	// 				]
	// 			: []),
	// 		{
	// 			Header: 'GL Assignment',
	// 			accessor: (row) => {
	// 				if (hasGlKey(row?.data)) {
	// 					return 'Complete';
	// 				}
	// 				return 'Incomplete';
	// 			},
	// 			Cell: ({ value }) => activeInactiveStatus(value),
	// 		},
	// 		{
	// 			Header: 'CC Assignment',
	// 			accessor: (row) => {
	// 				const ccAssignment = row.data?.refCCAssignmentIdentityId || row.refCCAssignmentIdentityId;
	// 				if (ccAssignment?.date) {
	// 					return 'Complete';
	// 				}
	// 				return 'Incomplete';
	// 			},
	// 			Cell: ({ value }) => activeInactiveStatus(value),
	// 		},
	// 		{
	// 			Header: 'Agreement Uploaded',
	// 			accessor: (row) => {
	// 				const agreementFiles = row.data?.agreementFiles || row.agreementFiles;
	// 				return agreementFiles && agreementFiles.length > 0 ? 'Complete' : 'Incomplete';
	// 			},

	// 			Cell: ({ value }) => (value === 'Complete' ? activeInactiveStatus(value) : activeInactiveStatus(`${value}WithWarning`)),
	// 		},
	// 		{
	// 			Header: 'Status',
	// 			accessor: (row) => row.activationStatus || 'N/A',
	// 			Cell: ({ value }) => {
	// 				return activeInactiveStatus(value);
	// 			},
	// 		},
	// 	],
	// 	[leaseList]
	// );

	// TanStack Table column definitions for IdentityFeaturedTable
	const TANSTACK_COLUMNS = useMemo(
		() => [
			{
				id: 'Selection',
				header: ({ table }) => (
					<IndeterminateCheckbox
						{...{
							checked: table.getIsAllRowsSelected(),
							indeterminate: table.getIsSomeRowsSelected(),
							onChange: table.getToggleAllRowsSelectedHandler(),
							sx: { color: '#858585', padding: '0px' },
						}}
					/>
				),
				cell: ({ row }) => (
					<IndeterminateCheckbox
						{...{
							checked: row.getIsSelected(),
							disabled: !row.getCanSelect(),
							indeterminate: row.getIsSomeSelected(),
							onChange: row.getToggleSelectedHandler(),
						}}
					/>
				),
				meta: {
					style: { textAlign: 'center', width: '60px' },
				},
				enableSorting: false,
				enableColumnFilter: false,
			},
			{
				header: 'Lease ID',
				accessorKey: 'leaseId',
				accessorFn: (row) => row.data?.leaseId || row.leaseId || 'N/A',
				dataType: 'text',
				enableColumnFilter: true,
			},
			{
				header: 'Lease Description',
				accessorKey: 'leaseTitle',
				accessorFn: (row) => row.data?.leaseTitle || row.leaseTitle || 'N/A',
				dataType: 'text',
				enableColumnFilter: true,
			},
			{
				dataType: 'text',
				header: 'Name of Lessor',
				accessorKey: 'lessorName',
				accessorFn: (row) => row.data?.lessorName || row.lessorName || 'N/A',
				enableColumnFilter: true,
				// isVisible: true,
			},
			{
				header: 'Lease Start Date',
				accessorKey: 'leaseStartDate',
				accessorFn: (row) => {
					const startDate = row.data?.leaseStartDate || row.leaseStartDate;
					// console.log(startDate, 'startDate123');
					// const formattedStartDate = ;
					// console.log(formattedStartDate, 'formatted startDate123');
					return startDate ? dayjs(startDate)?.format('YYYY-MM-DD') : 'N/A';
				},
				dataType: 'text',
				enableColumnFilter: true,
				cell: ({ getValue }) => {
					const value = getValue();

					return dayjs(value)?.format('YYYY-MM-DD') || 'N/A';
				},
			},
			{
				header: 'Lease End Date',
				accessorKey: 'leaseEndDate',
				accessorFn: (row) => {
					const endDate = row.data?.leaseEndDate || row.leaseEndDate;
					// if (String(row.data?.leaseId) === '100003') console.log('endDate123', endDate.split('T')[0]);

					const formattedDate = endDate ? endDate.split('T')[0] : 'N/A';
					return formattedDate;
				},
				dataType: 'text',
				enableColumnFilter: true,
				cell: ({ getValue }) => {
					const value = getValue();

					return dayjs(value)?.format('YYYY-MM-DD') || 'N/A';
				},
			},
			{
				header: 'Lease Term',
				accessorKey: 'leaseTerm',
				accessorFn: (row) => {
					const term = row.data?.leaseTerm || row.leaseTerm;
					return term ? `${term}` : 'N/A';
				},
				dataType: 'text',
				enableColumnFilter: true,
				meta: {
					style: { textAlign: 'center' },
				},
			},
			{
				header: 'Payment Modality',
				accessorKey: 'paymentModality',
				accessorFn: (row) => {
					const value = row.data?.paymentModality || row.paymentModality;
					return value === 'Start' ? 'Advance Basis' : 'Accrual Basis';
				},
				dataType: 'text',
				enableColumnFilter: true,
			},
			{
				header: 'Payment Frequency',
				accessorKey: 'paymentFrequency',
				accessorFn: (row) => row.data?.paymentFrequency || row.paymentFrequency || 'N/A',
				dataType: 'text',
				enableColumnFilter: true,
				meta: {
					style: { width: '160px' },
				},
			},
			{
				header: 'IBR',
				accessorKey: 'initialDiscountRate',
				accessorFn: (row) => {
					const rate = row.data?.initialDiscountRate || row.initialDiscountRate;
					return rate ? `${rate}` : 'N/A';
				},
				dataType: 'text',
				enableColumnFilter: true,
				meta: {
					style: { textAlign: 'center' },
				},
			},
			...(leaseList?.some((item) => item.approverFullName)
				? [
						{
							header: 'Approver',
							accessorKey: 'approverFullName',
							accessorFn: (row) => row.approverFullName || 'N/A',
							dataType: 'text',
							enableColumnFilter: true,
						},
					]
				: []),
			{
				header: 'GL Assignment',
				accessorKey: 'glAssignment',
				accessorFn: (row) => {
					if (hasGlKey(row?.data)) {
						return 'Complete';
					}
					return 'Incomplete';
				},
				cell: ({ getValue }) => activeInactiveStatus(getValue()),
				dataType: 'text',
				enableColumnFilter: true,
			},
			{
				header: 'CC Assignment',
				accessorKey: 'ccAssignment',
				accessorFn: (row) => {
					const ccAssignment = row.data?.refCCAssignmentIdentityId || row.refCCAssignmentIdentityId;
					if (ccAssignment?.date) {
						return 'Complete';
					}
					return 'Incomplete';
				},
				cell: ({ getValue }) => activeInactiveStatus(getValue()),
				dataType: 'text',
				enableColumnFilter: true,
			},
			{
				header: 'Agreement Uploaded',
				accessorKey: 'agreementUploaded',
				accessorFn: (row) => {
					const agreementFiles = row.data?.agreementFiles || row.agreementFiles;
					return agreementFiles && agreementFiles.length > 0 ? 'Complete' : 'Incomplete';
				},
				cell: ({ getValue }) => {
					const value = getValue();
					return value === 'Complete' ? activeInactiveStatus(value) : activeInactiveStatus(`${value}WithWarning`);
				},
				dataType: 'text',
				enableColumnFilter: true,
				meta: {
					style: { width: '170px' },
				},
			},
			{
				header: 'Status',
				accessorKey: 'activationStatus',
				accessorFn: (row) => row.activationStatus || 'N/A',
				cell: ({ getValue }) => activeInactiveStatus(getValue()),
				dataType: 'text',
				enableColumnFilter: true,
			},
		],
		[leaseList]
	);

	useEffect(() => {
		if (leaseList && leaseList.length > 0) {
			const PADDING = 45;
			const HEADER_FONT = 'bold 14px Arial';
			const CELL_FONT = '14px Arial';
			const newWidths = {};

			// const activeColumns = isRowClick ? COLUMNS : TANSTACK_COLUMNS;
			const activeColumns = TANSTACK_COLUMNS;

			activeColumns.forEach((column) => {
				const accessorKey = column.accessorKey || column.id;
				if (!accessorKey || accessorKey === 'Selection') return;

				const headerText = column.header || column.Header || accessorKey;

				// RENAME `maxWidth` to `calculatedWidth` for clarity
				let calculatedWidth = measureText(typeof headerText === 'function' ? accessorKey : headerText, HEADER_FONT);

				leaseList.forEach((row) => {
					let cellValue = '';
					if (column.accessorFn) {
						cellValue = column.accessorFn(row);
					} else if (column.accessor) {
						cellValue = column.accessor(row);
					}
					const cellWidth = measureText(cellValue ?? '', CELL_FONT);
					if (cellWidth > calculatedWidth) {
						calculatedWidth = cellWidth;
					}
				});

				// Get the defined max-width from our config
				const maxWidthConstraint = MAX_COLUMN_WIDTHS[accessorKey];

				// FINAL LOGIC: The width should be the SMALLER of the calculated width and the max-width constraint
				let finalWidth = Math.ceil(calculatedWidth + PADDING);

				if (maxWidthConstraint && finalWidth > maxWidthConstraint) {
					finalWidth = maxWidthConstraint;
				}

				newWidths[accessorKey] = finalWidth;
			});
			setColumnWidths(newWidths);
		}
	}, [leaseList, TANSTACK_COLUMNS]);

	// Handle row click - similar to navigateToDetails in IdentityCaseList
	const navigateToDetails = (row) => {
		navigate(routes.details, {
			state: {
				leaseDetails: row,
				leaseList,
				selectedTab: selectedTabName,
				_id: row._id || row.id,
				processCode: '10101',
				processName: 'Lease Records',
			},
		});
	};

	// const dynamicColumnStyles = useMemo(() => {
	// 	const styles = {};
	// 	for (const key in columnWidths) {
	// 		const finalWidth = columnWidths[key];

	// 		const tanstackIndex = TANSTACK_COLUMNS.findIndex((c) => (c.accessorKey || c.id) === key);
	// 		// const v7Index = COLUMNS.findIndex((c) => (c.id || c.accessorKey) === key);

	// 		// The style object is now simpler
	// 		const columnStyle = {
	// 			width: `${finalWidth}px`,
	// 			// minWidth is still good practice to prevent extreme shrinking
	// 			minWidth: `${finalWidth}px`,
	// 		};

	// 		if (tanstackIndex !== -1) {
	// 			styles[`& th:nth-of-type(${tanstackIndex + 1}), & td:nth-of-type(${tanstackIndex + 1})`] = columnStyle;
	// 		}

	// 		// if (v7Index !== -1) {
	// 		// 	styles[`& th:nth-of-type(${v7Index + 1}), & td:nth-of-type(${v7Index + 1})`] = columnStyle;
	// 		// }
	// 	}

	// 	return styles;
	// }, [columnWidths, TANSTACK_COLUMNS]);

	// const tableWrapperSx = useMemo(
	// 	() => ({
	// 		'& .MuiTable-root': {
	// 			// tableLayout: 'fixed',
	// 		},
	// 		'& th, & td': {
	// 			overflow: 'hidden',
	// 			textOverflow: 'ellipsis',
	// 			whiteSpace: 'nowrap',
	// 		},
	// 		'& td > div': {
	// 			maxWidth: 'none !important',
	// 		},
	// 		...dynamicColumnStyles,
	// 	}),
	// 	[dynamicColumnStyles]
	// );
	// Handle row click for ComptrollerDataTable
	// const handleRowClick = (row) => {
	// 	navigateToDetails(row);
	// };

	// Handle row selection for IdentityFeaturedTable
	const handleSelectRow = (row) => {
		if (headMetaData?.meta?.staticFormUrl?.startsWith('/static/') || permissionsObject?.write === true) {
			const url = headMetaData?.meta?.staticFormUrl ?? '/case-identity';
			const staticURL = headMetaData?.meta?.staticFormUrl;

			if (staticURL) {
				navigate(`${url}/details`, {
					state: {
						processCode: currentProcessDetails?.processCode,
						processName: currentProcessDetails?.name,
						_id: row?.id || row?._id,
						leaseDetails: row,
						leaseList,
						selectedTab: selectedTabName,
					},
				});
			} else {
				navigateToDetails(row);
			}
		} else {
			navigateToDetails(row);
		}
	};

	// Column filter function similar to IdentityCaseList
	// const renderColumnForTab = (selectedTab) => {
	// 	// For ComptrollerDataTable, filter columns based on tab if needed
	// 	const data = COLUMNS.filter((column) => {
	// 		if (column?.tabs && selectedTab && column?.tabs?.includes(selectedTab)) {
	// 			return false;
	// 		} else {
	// 			return true;
	// 		}
	// 	});

	// 	return data;
	// };

	// TanStack column filter function for IdentityFeaturedTable
	const renderTanStackColumnForTab = (selectedTab) => {
		const data = TANSTACK_COLUMNS.filter((column) => {
			if (column?.tabs && selectedTab && column?.tabs?.includes(selectedTab)) {
				return false;
			} else {
				return true;
			}
		});

		return data;
	};

	// Approve/Reject handler for IdentityFeaturedTable
	const approveRejectHandler = (data, status) => {
		// console.log(status, 'status123');
		const arr = [];
		const ids = [];

		if (Array.isArray(data)) {
			data?.forEach((item) => {
				if (item?.recordStatus === 'parked') {
					ids.push(item.id || item._id);
				} else {
					arr.push(item);
				}
			});
		} else {
			if (data?.recordStatus === 'parked') {
				ids.push(data);
			} else {
				arr.push(data);
			}
		}

		if (arr?.length > 0) {
			message.error({
				content: 'Your request is inconsistent with selection.',
				icon: <img src={controls} alt="inactive" width="16px" height="16px" style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
			});
		} else {
			setModalData({
				head: currentProcessDetails?.name,
				action: status,
				label:
					ids?.length > 1 ? (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>{status}</b> all?
						</p>
					) : (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>{status}</b>
							{!status?.includes('?') ? '?' : ''}
						</p>
					),
			});

			setSubmitData(ids);
			setShowModal(true);
		}
	};

	// const activeDeactivateHandle = (status) => {
	// 	let arr = [];
	// 	const recordStatusArr = [];
	//
	// 	if (status === 'Active') {
	// 		//////////////// // called when deactive button is clicked
	// 		setModalData({
	// 			head: currentProcessDetails?.name,
	// 			action: 'Inactive',
	// 			label:
	// 				rowSelection?.length > 1 ? (
	// 					<p>
	// 						{' '}
	// 						Do you want to <b style={{ fontSize: '1rem' }}>deactivate</b> all?
	// 					</p>
	// 				) : (
	// 					<p>
	// 						Do you want to <b
	// 						style={{ fontSize: '1rem' }}>deactivate</b> this {currentProcessDetails?.name?.toLowerCase()}?
	// 					</p>
	// 				),
	// 		});
	//
	// 		if (selectedRowKeys[status]) {
	// 			selectedRowKeys[status]?.map((item) => {
	// 				arr.push({
	// 					_id: item?._id,
	// 				});
	// 				// checked is there any parked data inside.
	// 				if (item?.recordStatus === 'parked') {
	// 					recordStatusArr.push(item);
	// 				}
	// 				return item;
	// 			});
	// 		}
	// 	} else if (status === 'Inactive') {
	// 		setModalData({
	// 			head: currentProcessDetails?.name,
	// 			action: 'Active',
	// 			label:
	// 				rowSelection?.length > 1 ? (
	// 					<p>
	// 						Do you want to <b style={{ fontSize: '1rem' }}>active</b> all?
	// 					</p>
	// 				) : (
	// 					<p>
	// 						Do you want to <b
	// 						style={{ fontSize: '1rem' }}>active</b> this {currentProcessDetails?.name?.toLowerCase()}?
	// 					</p>
	// 				),
	// 		});
	//
	// 		if (selectedRowKeys[status]) {
	// 			selectedRowKeys[status]?.forEach((item) => {
	// 				arr.push({
	// 					_id: item?._id,
	// 				});
	// 				// checked is there any parked data inside.
	// 				if (item?.recordStatus === 'parked') {
	// 					recordStatusArr.push(item);
	// 				}
	// 			});
	// 		} else if (selectedRowKeys['W-I-P']) {
	// 			selectedRowKeys['W-I-P']?.forEach((item) => {
	// 				arr.push({
	// 					_id: item?._id,
	// 				});
	// 				// checked is there any parked data inside.
	// 				if (item?.recordStatus === 'parked') {
	// 					recordStatusArr.push(item);
	// 				}
	// 			});
	// 		} else if (selectedRowKeys['null']) {
	// 			selectedRowKeys['null']?.forEach((item) => {
	// 				arr.push({
	// 					_id: item?._id,
	// 				});
	// 				// checked is there any parked data inside.
	// 				if (item?.recordStatus === 'parked') {
	// 					recordStatusArr.push(item);
	// 				}
	// 			});
	// 		}
	// 	} else if (status === 'submit') {
	// 		setModalData({
	// 			head: currentProcessDetails?.name,
	// 			action: 'Save',
	// 			label: (
	// 				<p>
	// 					Do you want to <b style={{ fontSize: '1rem' }}>submit</b> all?
	// 				</p>
	// 			),
	// 		});
	//
	// 		if (selectedRowKeys['Draft']) {
	// 			selectedRowKeys['Draft']?.forEach((item) => {
	//
	// 				arr.push(item.id);
	// 			});
	// 		}
	// 	}
	// 	if (arr?.length !== rowSelection?.length || recordStatusArr?.length > 0) {
	// 		message.error({
	// 			content: 'Your request is inconsistent with selection.',
	// 			icon: <img src={controls} alt="inactive" width="16px" height="16px"
	// 					   style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
	// 		});
	// 	} else {
	// 		setSubmitData(arr);
	// 		setShowModal(true);
	// 	}
	// };

	const activeDeactivateHandle = (status) => {
		if (status === 'submit') {
			// 1. Get only the selected items that are actually drafts.
			const draftItems = selectedRowKeys['draft'] || [];
			// console.log(draftItems,"draftItems123");

			// 2. Check if any drafts were selected at all.
			if (draftItems.length === 0) {
				message.error({
					content: 'No draft items selected for submission.',
					icon: <img src={controls} alt="inactive" width="16px" height="16px" style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
				});
				return; // Exit function
			}

			// 3. Ensure that all selected items are drafts.
			if (draftItems.length !== rowSelection.length) {
				message.error({
					content: 'Your request is inconsistent. Please select only draft items to submit.',
					icon: <img src={controls} alt="inactive" width="16px" height="16px" style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
				});
				return; // Exit function
			}

			// 4. If all checks pass, prepare data and show the modal.
			const idsToSubmit = draftItems.map((item) => item._id);

			setModalData({
				head: currentProcessDetails?.name,
				action: 'Save', // Triggers the correct 'Save' block in modalSubmitHandler
				label: (
					<p>
						Do you want to <b style={{ fontSize: '1rem' }}>submit</b> all selected drafts?
					</p>
				),
			});

			setSubmitData(idsToSubmit);
			setShowModal(true);
			return; // IMPORTANT: Exit the function so the generic validation below is not run.
		}
		// --- END: DEDICATED LOGIC FOR SUBMIT ACTION ---

		// The rest of the function for 'Active'/'Inactive' remains untouched and works as before.
		let arr = [];
		const recordStatusArr = [];

		if (status === 'Active') {
			setModalData({
				head: currentProcessDetails?.name,
				action: 'Inactive',
				label:
					rowSelection?.length > 1 ? (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>deactivate</b> all?
						</p>
					) : (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>deactivate</b> this {currentProcessDetails?.name?.toLowerCase()}?
						</p>
					),
			});

			if (selectedRowKeys[status]) {
				selectedRowKeys[status]?.forEach((item) => {
					arr.push({ _id: item?._id });
					if (item?.recordStatus === 'parked') {
						recordStatusArr.push(item);
					}
				});
			}
		} else if (status === 'Inactive') {
			setModalData({
				head: currentProcessDetails?.name,
				action: 'Active',
				label:
					rowSelection?.length > 1 ? (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>active</b> all?
						</p>
					) : (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>active</b> this {currentProcessDetails?.name?.toLowerCase()}?
						</p>
					),
			});

			if (selectedRowKeys[status]) {
				selectedRowKeys[status]?.forEach((item) => {
					arr.push({ _id: item?._id });
					if (item?.recordStatus === 'parked') {
						recordStatusArr.push(item);
					}
				});
			} else if (selectedRowKeys['W-I-P']) {
				selectedRowKeys['W-I-P']?.forEach((item) => {
					arr.push({ _id: item?._id });
					if (item?.recordStatus === 'parked') {
						recordStatusArr.push(item);
					}
				});
			} else if (selectedRowKeys['null']) {
				selectedRowKeys['null']?.forEach((item) => {
					arr.push({ _id: item?._id });
					if (item?.recordStatus === 'parked') {
						recordStatusArr.push(item);
					}
				});
			}
		}

		// This generic validation now only runs for 'Active' and 'Inactive' actions.
		if (arr.length !== rowSelection.length || recordStatusArr.length > 0) {
			message.error({
				content: 'Your request is inconsistent with selection.',
				icon: <img src={controls} alt="inactive" width="16px" height="16px" style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
			});
		} else {
			setSubmitData(arr);
			setShowModal(true);
		}
	};
	const modalSubmitHandler = () => {
		if (modalData?.action === 'Active') {
			const payload = {
				_id: submitData.map((item) => item._id),
				operation: 'activate-bulk',
				processCode: currentProcessDetails?.processCode,
				activationStatus: 'Active',
			};

			IdentityBulk(payload);
		} else if (modalData?.action === 'Inactive') {
			const payload = {
				_id: submitData.map((item) => item._id),
				operation: 'activate-bulk',
				processCode: currentProcessDetails?.processCode,
				activationStatus: 'Inactive',
			};

			IdentityBulk(payload);
		} else if (modalData?.action === 'Approve') {
			IdentityBulk({
				_id: submitData,
				operation: 'approve-bulk',
				processCode: currentProcessDetails.processCode,
				suffixCode: '',
			});
		} else if (modalData?.action === 'Reject') {
			IdentityBulk({
				_id: submitData,
				operation: 'reject-bulk',
				processCode: currentProcessDetails.processCode,
			});
		} else if (modalData?.action === 'Save') {
			// This is triggered by the 'Submit' button

			const payload = {
				_id: submitData,
				operation: 'submit-draft-bulk',
				processCode: currentProcessDetails.processCode,
				suffixCode: '',
			};

			IdentityBulk(payload);
		}
	};

	// const leaseManagementActions = useMemo(() => {
	// 	const buttons = [];
	// 	if (selectedTabName === 'Draft') {
	// 		buttons.push({
	// 			title: 'Submit',
	// 			onClick: () => activeDeactivateHandle('submit'),
	// 			color: theme.palette.lynTheme.success,
	// 			textColor: 'white',
	// 		});
	// 	}
	// 	if (selectedTabName === 'Active') {
	// 		buttons.push({
	// 			title: 'Deactivate',
	// 			onClick: () => activeDeactivateHandle('Active'),
	// 			color: theme.palette.lynTheme.submit,
	// 			textColor: 'white',
	// 		});
	// 	}
	// 	if (selectedTabName === 'Inactive') {
	// 		buttons.push({
	// 			title: 'Activate',
	// 			onClick: () => activeDeactivateHandle('Inactive'),
	// 			color: theme.palette.lynTheme.success,
	// 			textColor: 'white',
	// 		});
	// 	}
	// 	// 'W-I-P' and 'All' tabs will result in an empty array, showing no buttons.
	// 	return buttons;
	// }, [selectedTabName, activeDeactivateHandle, theme]);

	const buttonVisibility = useMemo(
		() => ({
			submit: selectedTabName === 'Draft',
			deactivate: selectedTabName === 'Active',
			activate: selectedTabName === 'Inactive',
			approveReject: !['Active', 'NEW_INACTIVE', 'Inactive', 'Draft', 'All', 'W-I-P'].includes(selectedTabName),
		}),
		[selectedTabName]
	);

	return (
		<Box>
			<Spin spinning={isLoading || isBulkActionLoading}>
				{/* {!leaseList || leaseList.length === 0 ? (
					<Box sx={{ mt: 3 }}>
						<ComptrollerDataTable
							selectedTabName={'All'}
							DATA={[]}
							COLUMNS={renderColumnForTab('All')}
							setRowSelection={setRowSelection}
							rowSelection={rowSelection}
							onClickHandler={navigateToDetails}
							activeDeactivateHandle={activeDeactivateHandle}
							xlsxFileName={currentProcessDetails?.name || 'lease-records'}
							bulkDelete={false}
							balkAction={true}
							columnButton={false}
							exportButton={false}
						/>
					</Box>
				) : ( */}
				<IdentityFeaturedTable
					columns={renderTanStackColumnForTab(selectedTabName)}
					setData={setData}
					rowSelection={rowSelection}
					processDetails={currentProcessDetails}
					xlsxFileName={currentProcessDetails?.name || 'lease-records'}
					setRowSelection={setRowSelection}
					data={leaseList ?? []}
					approveRejectHandler={approveRejectHandler}
					activeDeactivateHandle={activeDeactivateHandle}
					selectedTabName={selectedTabName}
					expectedURLToRedirect={expectedURLToRedirect}
					handleSelectRow={handleSelectRow}
					buttonVisibility={buttonVisibility}
				/>
				{/* )} */}

				{showModal && (
					<ComptrollerConfirmModal
						showModal={showModal}
						setShowModal={setShowModal}
						modalData={modalData}
						handleSubmit={modalSubmitHandler}
					/>
				)}
			</Spin>
		</Box>
	);
};

export default ListViewLeaseManagementArea;
